export default {
  init: {
    minWait: 3000,
  },
  task: {
    waitLast: 3000,
  },
};
